export class Tooltip {
	index: number;
	label: string;
}